// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-container{
    padding-top:19.92px;
    max-width:1100px;
    margin:auto;
}

.report-header{
    display:none;
}

.report-header-mobile{
    display:block;
    background:#0f172a;
    color:white;
    padding:10px;
}

.report-logo{
    font-size:32px;
    font-weight:bold;
}

.report-logo span{
    color:#dc2626;
}

.report-id{
    margin-top:10px;
    color:#cbd5e1;
}

.report-id-mobile{
    margin-top:10px;
    font-size:8px;
    color:#cbd5e1;
}

.report-section{
    background:white;
    margin-top:25px;
    border-radius:12px;
    padding:25px;
    box-shadow:0 5px 15px rgba(0,0,0,.08);
}

.report-map{
    display:none;
}

.report-map-mobile{
    display:block;
}

.diagram-column{
    display:flex;
    position:relative;
    align-items:center;
    flex:2;
}

.diagram-spacer{
    flex:1;
}

.diagram-column img{
    width:100%;
    display:block;
}

.diagram-column h3{
    margin-left:16px;
}

.diagram-marker {
   position: absolute;
   z-index: 10;

   /* Spot Styling */
   width: 15px;
   height: 15px;
   background-color: #ff3b30;
   border-radius: 50%;
   border: 2px solid white;
   box-shadow: 0 0 8px rgba(0,0,0,0.5);

   /* CRITICAL: Centers the spot exactly on the (40%, 30%) point */
   transform: translate(-50%, -50%);
}

.report-section h2{
    margin-top:0;
    margin-bottom:19.92px;
    color:#0f172a;
    border-left:5px solid #dc2626;
    padding-left:10px;
}

.summary-grid{
    display:none;
    grid-template-columns:repeat(4,1fr);
    gap:20px;
}

.summary-grid-mobile{
    display:block;
}

.price-tag-mobile{
    margin-bottom:12px;
}

.card{
    background:#f8fafc;
    padding:20px;
    border-radius:10px;
    text-align:center;
}

.card h3{
    margin:0;
    font-size:15px;
    color:#64748b;
}

.card p{
    font-size:22px;
    font-weight:bold;
    margin-top:10px;
}

.grade{
    display:inline-block;
    color:white;
    padding:12px 25px;
    border-radius:30px;
    font-size:20px;
    font-weight:bold;
}

.notice{
    background:#eff6ff;
    border-left:5px solid #3b82f6;
    padding:20px;
    border-radius:8px;
}

.vehicle-map{
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:10px;
    text-align:center;
    margin-top:20px;
}

.panel{
    padding:15px;
    border-radius:8px;
    font-weight:bold;
}

.original{
    background:#dcfce7;
}

.repaired{
    background:#fef3c7;
}

.major{
    background:#fee2e2;
}

table{
    width:100%;
    border-collapse:collapse;
}

table th{
    background:#0f172a;
    color:white;
    padding:12px;
}

table td{
    padding:12px;
    border-bottom:1px solid #ddd;
}

.pass{
    color:green;
    font-weight:bold;
}

.warning{
    color:#d97706;
    font-weight:bold;
}

.fail{
    color:red;
    font-weight:bold;
}

.verdict{
    background:#f8fafc;
    padding:25px;
    border-radius:10px;
    border:2px solid #e2e8f0;
}

.verdict h3{
    margin-top:0;
    color:#dc2626;
}

.report-footer{
    text-align:center;
    margin-top:40px;
    color:#64748b;
}

/* IMAGE GALLERY */

.gallery-grid{
    display:none;
}

.gallery-grid-mobile{
    position:relative;
    display:flex;
    margin-bottom: 12px;
    overflow: hidden;
}

.gallery-grid-mobile img {
  width: 100%;        /* Forces image to match the container width */
  max-width: 100%;    /* Prevents it from going wider than the screen */
  height: auto;       /* Maintains the image's original aspect ratio */
  display: block;     /* Removes weird default bottom spacing */
}

.main-photo{
    grid-column: 1;      /* Places it in the 2fr column */
    grid-row: span 2;    /* Spans down across 2 rows */
    aspect-ratio: 4 / 3;
    position:relative;
    cursor:pointer;
}

.side-photo{
    position:relative;
    cursor:pointer;
}

.gallery-grid img{
    width:100%;
    height:100%;
    object-fit:cover;
}

.photo-label{
    position:absolute;
    bottom:0;
    width:100%;
    background:rgba(0,0,0,.65);
    color:white;
    padding:10px;
}

.gallery-price-div {
  position: absolute;
  margin: 20px 20px; 
  bottom: 0%;
  left: 0%;
}

.gallery-price-text {
  margin: 0px;
  color: #FFFFFF;
  text-shadow : 1px 1px black;
  font-size: 2em;
}

.gallery-installment-text {
  margin: 0px;
  color: #FFFFFF;
  text-shadow : 1px 1px black;
  font-size: 1em;
  font-weight: 700;
}

.overlay{
    position:absolute;
    inset:0;
    background:rgba(0,0,0,.6);
    color:white;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:32px;
    font-weight:bold;
}

/* FULL SCREEN MODAL */

.gallery-modal{
    display:flex;
    position:fixed;
    z-index:99999;
    inset:0;
    background:rgba(0,0,0,.95);
    justify-content:center;
    align-items:center;
}

.modal-image{
    min-width:min(360px, 100%);
    max-height:85vh;
    object-fit:contain;
}



.close-modal{
    position:absolute;
    top:20px;
    right:35px;
    color:white;
    font-size:50px;
    cursor:pointer;
}

.modal-caption{

    position:absolute;

    bottom:0;
    left:0;

    width:100%;

    background:rgba(0,0,0,.8);

    color:white;

    padding:20px 40px;
}

.modal-caption h3{
    margin-bottom:5px;
}

.nav-btn{

    position:absolute;
    top:50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    
    transform:translateY(-50%);

    background:rgba(255,255,255,.15);

    border:none;

    color:white;

    font-size:50px;

    width:50px;
    height:50px;
    line-height: 50px;

    cursor:pointer;

    border-radius:50%;
}

.nav-btn:hover{
    background:rgba(255,255,255,.25);
}

.prev-btn{
    left:10px;
}

.next-btn{
    right:10px;
}

/******MOBILE IMAGE GALLERY******/
.slider-wrapper {
  max-width: 600px;
  width: 90%;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  cursor: grab;
  user-select: none;
  
  /* Hide scrollbars */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.slider-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.slider-wrapper.dragging {
  cursor: grabbing;
  scroll-snap-type: none;
  scroll-behavior: auto;
}

/* Carousel Track */
.slider-carousel {
  display: flex;
  list-style: none;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* Individual Image Cards */
.slider-card {
  min-width: 100%;
  height: 100%;
  scroll-snap-align: center;
}

.slider-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none; /* Crucial to allow mouse tracking instead of native image drag */
}
/******MOBILE IMAGE GALLERY END******/

@media (min-width: 768px) {
  .report-header{
    display:block;
    background:#0f172a;
    color:white;
    padding:30px;
    border-radius:12px;
  }
  .report-header-mobile{
    display:none;
  }
  .gallery-grid-mobile {
    display: none;
  }
  .gallery-grid {
    position:relative;
    display:grid;
    grid-template-columns:2fr 1fr 1fr;
    grid-auto-rows: auto;
    gap:4px;
    margin-bottom: 19.92px;
    overflow: hidden;
  }
  .summary-grid{
    display:grid;
  }
  .summary-grid-mobile{
    display:none;
  }
  .report-map{
    display:flex;
  }
  .report-map-mobile{
    display:none;
  }
}

@media(max-width:768px){
  .summary-grid{
    grid-template-columns:1fr 1fr;
  }

  .vehicle-map{
    grid-template-columns:1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Report/css/Report.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;GACG,kBAAkB;GAClB,WAAW;;GAEX,iBAAiB;GACjB,WAAW;GACX,YAAY;GACZ,yBAAyB;GACzB,kBAAkB;GAClB,uBAAuB;GACvB,mCAAmC;;GAEnC,+DAA+D;GAC/D,gCAAgC;AACnC;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,QAAQ;IACR,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,QAAQ;IACR,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;AACjB;;AAEA,kBAAkB;;AAElB;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;EACE,WAAW,SAAS,8CAA8C;EAClE,eAAe,KAAK,iDAAiD;EACrE,YAAY,QAAQ,gDAAgD;EACpE,cAAc,MAAM,yCAAyC;AAC/D;;AAEA;IACI,cAAc,OAAO,gCAAgC;IACrD,gBAAgB,KAAK,6BAA6B;IAClD,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,UAAU;IACV,0BAA0B;IAC1B,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,sBAAsB;;AAEtB;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,OAAO;IACP,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;;;;AAIA;IACI,iBAAiB;IACjB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,cAAc;IACd,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;;IAEjB,QAAQ;IACR,MAAM;;IAEN,UAAU;;IAEV,yBAAyB;;IAEzB,WAAW;;IAEX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,OAAO;IACP,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,0BAA0B;;IAE1B,gCAAgC;;IAEhC,WAAW;;IAEX,WAAW;;IAEX,cAAc;;IAEd,UAAU;IACV,WAAW;IACX,iBAAiB;;IAEjB,cAAc;;IAEd,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;;EAEjB,oBAAoB;EACpB,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB,EAAE,iEAAiE;AACzF;AACA,qCAAqC;;AAErC;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iCAAiC;IACjC,oBAAoB;IACpB,OAAO;IACP,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".report-container{\r\n    padding-top:19.92px;\r\n    max-width:1100px;\r\n    margin:auto;\r\n}\r\n\r\n.report-header{\r\n    display:none;\r\n}\r\n\r\n.report-header-mobile{\r\n    display:block;\r\n    background:#0f172a;\r\n    color:white;\r\n    padding:10px;\r\n}\r\n\r\n.report-logo{\r\n    font-size:32px;\r\n    font-weight:bold;\r\n}\r\n\r\n.report-logo span{\r\n    color:#dc2626;\r\n}\r\n\r\n.report-id{\r\n    margin-top:10px;\r\n    color:#cbd5e1;\r\n}\r\n\r\n.report-id-mobile{\r\n    margin-top:10px;\r\n    font-size:8px;\r\n    color:#cbd5e1;\r\n}\r\n\r\n.report-section{\r\n    background:white;\r\n    margin-top:25px;\r\n    border-radius:12px;\r\n    padding:25px;\r\n    box-shadow:0 5px 15px rgba(0,0,0,.08);\r\n}\r\n\r\n.report-map{\r\n    display:none;\r\n}\r\n\r\n.report-map-mobile{\r\n    display:block;\r\n}\r\n\r\n.diagram-column{\r\n    display:flex;\r\n    position:relative;\r\n    align-items:center;\r\n    flex:2;\r\n}\r\n\r\n.diagram-spacer{\r\n    flex:1;\r\n}\r\n\r\n.diagram-column img{\r\n    width:100%;\r\n    display:block;\r\n}\r\n\r\n.diagram-column h3{\r\n    margin-left:16px;\r\n}\r\n\r\n.diagram-marker {\r\n   position: absolute;\r\n   z-index: 10;\r\n\r\n   /* Spot Styling */\r\n   width: 15px;\r\n   height: 15px;\r\n   background-color: #ff3b30;\r\n   border-radius: 50%;\r\n   border: 2px solid white;\r\n   box-shadow: 0 0 8px rgba(0,0,0,0.5);\r\n\r\n   /* CRITICAL: Centers the spot exactly on the (40%, 30%) point */\r\n   transform: translate(-50%, -50%);\r\n}\r\n\r\n.report-section h2{\r\n    margin-top:0;\r\n    margin-bottom:19.92px;\r\n    color:#0f172a;\r\n    border-left:5px solid #dc2626;\r\n    padding-left:10px;\r\n}\r\n\r\n.summary-grid{\r\n    display:none;\r\n    grid-template-columns:repeat(4,1fr);\r\n    gap:20px;\r\n}\r\n\r\n.summary-grid-mobile{\r\n    display:block;\r\n}\r\n\r\n.price-tag-mobile{\r\n    margin-bottom:12px;\r\n}\r\n\r\n.card{\r\n    background:#f8fafc;\r\n    padding:20px;\r\n    border-radius:10px;\r\n    text-align:center;\r\n}\r\n\r\n.card h3{\r\n    margin:0;\r\n    font-size:15px;\r\n    color:#64748b;\r\n}\r\n\r\n.card p{\r\n    font-size:22px;\r\n    font-weight:bold;\r\n    margin-top:10px;\r\n}\r\n\r\n.grade{\r\n    display:inline-block;\r\n    color:white;\r\n    padding:12px 25px;\r\n    border-radius:30px;\r\n    font-size:20px;\r\n    font-weight:bold;\r\n}\r\n\r\n.notice{\r\n    background:#eff6ff;\r\n    border-left:5px solid #3b82f6;\r\n    padding:20px;\r\n    border-radius:8px;\r\n}\r\n\r\n.vehicle-map{\r\n    display:grid;\r\n    grid-template-columns:repeat(3,1fr);\r\n    gap:10px;\r\n    text-align:center;\r\n    margin-top:20px;\r\n}\r\n\r\n.panel{\r\n    padding:15px;\r\n    border-radius:8px;\r\n    font-weight:bold;\r\n}\r\n\r\n.original{\r\n    background:#dcfce7;\r\n}\r\n\r\n.repaired{\r\n    background:#fef3c7;\r\n}\r\n\r\n.major{\r\n    background:#fee2e2;\r\n}\r\n\r\ntable{\r\n    width:100%;\r\n    border-collapse:collapse;\r\n}\r\n\r\ntable th{\r\n    background:#0f172a;\r\n    color:white;\r\n    padding:12px;\r\n}\r\n\r\ntable td{\r\n    padding:12px;\r\n    border-bottom:1px solid #ddd;\r\n}\r\n\r\n.pass{\r\n    color:green;\r\n    font-weight:bold;\r\n}\r\n\r\n.warning{\r\n    color:#d97706;\r\n    font-weight:bold;\r\n}\r\n\r\n.fail{\r\n    color:red;\r\n    font-weight:bold;\r\n}\r\n\r\n.verdict{\r\n    background:#f8fafc;\r\n    padding:25px;\r\n    border-radius:10px;\r\n    border:2px solid #e2e8f0;\r\n}\r\n\r\n.verdict h3{\r\n    margin-top:0;\r\n    color:#dc2626;\r\n}\r\n\r\n.report-footer{\r\n    text-align:center;\r\n    margin-top:40px;\r\n    color:#64748b;\r\n}\r\n\r\n/* IMAGE GALLERY */\r\n\r\n.gallery-grid{\r\n    display:none;\r\n}\r\n\r\n.gallery-grid-mobile{\r\n    position:relative;\r\n    display:flex;\r\n    margin-bottom: 12px;\r\n    overflow: hidden;\r\n}\r\n\r\n.gallery-grid-mobile img {\r\n  width: 100%;        /* Forces image to match the container width */\r\n  max-width: 100%;    /* Prevents it from going wider than the screen */\r\n  height: auto;       /* Maintains the image's original aspect ratio */\r\n  display: block;     /* Removes weird default bottom spacing */\r\n}\r\n\r\n.main-photo{\r\n    grid-column: 1;      /* Places it in the 2fr column */\r\n    grid-row: span 2;    /* Spans down across 2 rows */\r\n    aspect-ratio: 4 / 3;\r\n    position:relative;\r\n    cursor:pointer;\r\n}\r\n\r\n.side-photo{\r\n    position:relative;\r\n    cursor:pointer;\r\n}\r\n\r\n.gallery-grid img{\r\n    width:100%;\r\n    height:100%;\r\n    object-fit:cover;\r\n}\r\n\r\n.photo-label{\r\n    position:absolute;\r\n    bottom:0;\r\n    width:100%;\r\n    background:rgba(0,0,0,.65);\r\n    color:white;\r\n    padding:10px;\r\n}\r\n\r\n.gallery-price-div {\r\n  position: absolute;\r\n  margin: 20px 20px; \r\n  bottom: 0%;\r\n  left: 0%;\r\n}\r\n\r\n.gallery-price-text {\r\n  margin: 0px;\r\n  color: #FFFFFF;\r\n  text-shadow : 1px 1px black;\r\n  font-size: 2em;\r\n}\r\n\r\n.gallery-installment-text {\r\n  margin: 0px;\r\n  color: #FFFFFF;\r\n  text-shadow : 1px 1px black;\r\n  font-size: 1em;\r\n  font-weight: 700;\r\n}\r\n\r\n.overlay{\r\n    position:absolute;\r\n    inset:0;\r\n    background:rgba(0,0,0,.6);\r\n    color:white;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center;\r\n    font-size:32px;\r\n    font-weight:bold;\r\n}\r\n\r\n/* FULL SCREEN MODAL */\r\n\r\n.gallery-modal{\r\n    display:flex;\r\n    position:fixed;\r\n    z-index:99999;\r\n    inset:0;\r\n    background:rgba(0,0,0,.95);\r\n    justify-content:center;\r\n    align-items:center;\r\n}\r\n\r\n.modal-image{\r\n    min-width:min(360px, 100%);\r\n    max-height:85vh;\r\n    object-fit:contain;\r\n}\r\n\r\n\r\n\r\n.close-modal{\r\n    position:absolute;\r\n    top:20px;\r\n    right:35px;\r\n    color:white;\r\n    font-size:50px;\r\n    cursor:pointer;\r\n}\r\n\r\n.modal-caption{\r\n\r\n    position:absolute;\r\n\r\n    bottom:0;\r\n    left:0;\r\n\r\n    width:100%;\r\n\r\n    background:rgba(0,0,0,.8);\r\n\r\n    color:white;\r\n\r\n    padding:20px 40px;\r\n}\r\n\r\n.modal-caption h3{\r\n    margin-bottom:5px;\r\n}\r\n\r\n.nav-btn{\r\n\r\n    position:absolute;\r\n    top:50%;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    \r\n    transform:translateY(-50%);\r\n\r\n    background:rgba(255,255,255,.15);\r\n\r\n    border:none;\r\n\r\n    color:white;\r\n\r\n    font-size:50px;\r\n\r\n    width:50px;\r\n    height:50px;\r\n    line-height: 50px;\r\n\r\n    cursor:pointer;\r\n\r\n    border-radius:50%;\r\n}\r\n\r\n.nav-btn:hover{\r\n    background:rgba(255,255,255,.25);\r\n}\r\n\r\n.prev-btn{\r\n    left:10px;\r\n}\r\n\r\n.next-btn{\r\n    right:10px;\r\n}\r\n\r\n/******MOBILE IMAGE GALLERY******/\r\n.slider-wrapper {\r\n  max-width: 600px;\r\n  width: 90%;\r\n  aspect-ratio: 16 / 9;\r\n  border-radius: 12px;\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\r\n  overflow-x: auto;\r\n  scroll-snap-type: x mandatory;\r\n  scroll-behavior: smooth;\r\n  cursor: grab;\r\n  user-select: none;\r\n  \r\n  /* Hide scrollbars */\r\n  -ms-overflow-style: none;  /* IE and Edge */\r\n  scrollbar-width: none;  /* Firefox */\r\n}\r\n\r\n.slider-wrapper::-webkit-scrollbar {\r\n  display: none; /* Chrome, Safari and Opera */\r\n}\r\n\r\n.slider-wrapper.dragging {\r\n  cursor: grabbing;\r\n  scroll-snap-type: none;\r\n  scroll-behavior: auto;\r\n}\r\n\r\n/* Carousel Track */\r\n.slider-carousel {\r\n  display: flex;\r\n  list-style: none;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* Individual Image Cards */\r\n.slider-card {\r\n  min-width: 100%;\r\n  height: 100%;\r\n  scroll-snap-align: center;\r\n}\r\n\r\n.slider-card img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  pointer-events: none; /* Crucial to allow mouse tracking instead of native image drag */\r\n}\r\n/******MOBILE IMAGE GALLERY END******/\r\n\r\n@media (min-width: 768px) {\r\n  .report-header{\r\n    display:block;\r\n    background:#0f172a;\r\n    color:white;\r\n    padding:30px;\r\n    border-radius:12px;\r\n  }\r\n  .report-header-mobile{\r\n    display:none;\r\n  }\r\n  .gallery-grid-mobile {\r\n    display: none;\r\n  }\r\n  .gallery-grid {\r\n    position:relative;\r\n    display:grid;\r\n    grid-template-columns:2fr 1fr 1fr;\r\n    grid-auto-rows: auto;\r\n    gap:4px;\r\n    margin-bottom: 19.92px;\r\n    overflow: hidden;\r\n  }\r\n  .summary-grid{\r\n    display:grid;\r\n  }\r\n  .summary-grid-mobile{\r\n    display:none;\r\n  }\r\n  .report-map{\r\n    display:flex;\r\n  }\r\n  .report-map-mobile{\r\n    display:none;\r\n  }\r\n}\r\n\r\n@media(max-width:768px){\r\n  .summary-grid{\r\n    grid-template-columns:1fr 1fr;\r\n  }\r\n\r\n  .vehicle-map{\r\n    grid-template-columns:1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
